import auth from "./auth";
const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const fetcher = async ({
  baseUrl = BASE_URL,
  route = "/",
  method = "GET",
  query = null,
  parameter = null,
  body = null,
  token = null,
}) => {
  try {
    // ✅ สร้าง query string
    let queryString = "";
    if (query && Object.keys(query).length > 0) {
      queryString =
        "?" +
        new URLSearchParams(
          Object.fromEntries(
            Object.entries(query).filter(
              ([_, v]) => v !== undefined && v !== null
            )
          )
        ).toString();
    }

    // ✅ ใส่ parameter ถ้ามี
    let url = `${baseUrl}${route}`;
    if (parameter) {
      url = `${url}/${encodeURIComponent(parameter)}`;
    }

    // ✅ กำหนด header
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    // ✅ สร้าง option
    const options = {
      method,
      headers,
    };
    if (body) {
      options.body = JSON.stringify(body);
    }

    // ✅ fetch
    const response = await fetch(url + queryString, options);
    const json = await response.json();

    return { ok: response.ok, json };

    // ✅ ตรวจสอบสถานะ response
    if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      throw json;
    }

    // ✅ พยายาม parse JSON
    let result = null;
    const text = await response.text();
    try {
      result = text ? JSON.parse(text) : null;
    } catch {
      result = text; // ถ้าไม่ใช่ JSON ให้คืนเป็น string
    }

    return result;
  } catch (error) {
    console.error("❌ Fetch error:", error);
    throw error;
  }
};

const apis = { auth };

export default apis;
